import { IMAGES } from "@/assets/images";
import { Espacio, MenuItem, Testimonio } from "@/lib/index";

export const espacios: Espacio[] = [
  {
    id: "1",
    nombre: "Restaurante Las Gaviotas",
    slug: "restaurante-las-gaviotas",
    tagline: "El sabor tradicional del Mar de Cortés",
    descripcion: "Nuestro restaurante insignia donde la tradición sinaloense cobra vida con los mariscos más frescos de la región.",
    descripcionLarga: "Ubicado frente a las hermosas dunas de El Maviri, Restaurante Las Gaviotas es un referente gastronómico en Ahome. Con más de 20 años de tradición, ofrecemos una experiencia culinaria única donde el sonido de las olas y el sabor del pescado zarandeado se fusionan para crear recuerdos inolvidables.",
    imagenPrincipal: IMAGES.RESTAURANT_DINING_1,
    galeria: [
      IMAGES.RESTAURANT_DINING_2,
      IMAGES.RESTAURANT_DINING_3,
      IMAGES.RESTAURANT_DINING_4
    ],
    amenidades: [
      "Vista al mar",
      "Área infantil",
      "Estacionamiento privado",
      "Música en vivo los fines de semana",
      "Acceso directo a la playa"
    ],
    horario: "Lunes a Domingo, 10:00 AM - 8:00 PM",
    rangoPrecio: "$$ - $$$"
  },
  {
    id: "2",
    nombre: "Cabañas Las Gaviotas",
    slug: "cabanas-las-gaviotas",
    tagline: "Tu refugio privado entre dunas y mar",
    descripcion: "Descansa en nuestras exclusivas cabañas diseñadas para ofrecerte confort absoluto en contacto directo con la naturaleza.",
    descripcionLarga: "Diseñadas con un estilo costero orgánico, nuestras cabañas ofrecen el equilibrio perfecto entre lujo y sencillez. Despierta con el amanecer sobre el Pacífico y disfruta de la tranquilidad que solo Playa El Maviri puede ofrecer. Cada cabaña cuenta con terraza privada y amenidades premium para una estancia placentera.",
    imagenPrincipal: IMAGES.CABANAS_2,
    galeria: [
      IMAGES.CABANAS_1,
      IMAGES.CABANAS_3,
      IMAGES.CABANAS_5
    ],
    amenidades: [
      "Aire acondicionado",
      "Wi-Fi de alta velocidad",
      "Terraza privada",
      "Servicio al cuarto",
      "Área de fogata"
    ],
    horario: "Check-in: 3:00 PM | Check-out: 12:00 PM",
    rangoPrecio: "$$$"
  },
  {
    id: "3",
    nombre: "Restaurante Medusas",
    slug: "restaurante-medusas",
    tagline: "Cocina de autor y mixología frente al horizonte",
    descripcion: "Una propuesta contemporánea que eleva los ingredientes locales a una experiencia sensorial sofisticada.",
    descripcionLarga: "Medusas es nuestra propuesta más vanguardista. Con un enfoque en la frescura extrema y técnicas modernas, presentamos platillos que son verdaderas obras de arte. Nuestra barra de mixología es famosa por sus creaciones inspiradas en los atardeceres de Sinaloa, convirtiéndonos en el lugar ideal para cenas románticas y celebraciones especiales.",
    imagenPrincipal: IMAGES.SEAFOOD_RESTAURANT_2,
    galeria: [
      IMAGES.SEAFOOD_RESTAURANT_5,
      IMAGES.SEAFOOD_RESTAURANT_8,
      IMAGES.RESTAURANT_DINING_6
    ],
    amenidades: [
      "Bar de mixología",
      "Área lounge",
      "Ambiente exclusivo",
      "DJ en vivo",
      "Cenas privadas"
    ],
    horario: "Miércoles a Lunes, 1:00 PM - 11:00 PM",
    rangoPrecio: "$$$ - $$$$"
  }
];

export const menuItems: MenuItem[] = [
  {
    id: "m1",
    nombre: "Pescado Zarandeado Especial",
    precio: 450,
    descripcion: "Pescado fresco del día marinado en nuestra salsa secreta de chiles y especias, asado lentamente a la leña.",
    categoria: "especialidades",
    imagen: IMAGES.SEAFOOD_RESTAURANT_3,
    esPopular: true,
    origen: "Gaviotas"
  },
  {
    id: "m2",
    nombre: "Aguachile Verde Sinaloense",
    precio: 280,
    descripcion: "Camarones frescos marinados en limón, chile serrano, cilantro y pepino. Un clásico de la región.",
    categoria: "mariscos",
    imagen: IMAGES.SEAFOOD_RESTAURANT_1,
    esPopular: true,
    origen: "Gaviotas"
  },
  {
    id: "m3",
    nombre: "Tostada Medusa Real",
    precio: 195,
    descripcion: "Láminas de atún aleta amarilla con emulsión de habanero tatemado y crujiente de poro.",
    categoria: "entradas",
    imagen: IMAGES.SEAFOOD_RESTAURANT_7,
    esPopular: true,
    origen: "Medusas"
  },
  {
    id: "m4",
    nombre: "Camarones al Coco con Mango",
    precio: 340,
    descripcion: "Camarones gigantes empanizados con coco natural, acompañados de una reducción de mango y habanero.",
    categoria: "especialidades",
    imagen: IMAGES.SEAFOOD_RESTAURANT_6,
    origen: "Gaviotas"
  },
  {
    id: "m5",
    nombre: "Pulpo a las Brasas con Chimichurri",
    precio: 390,
    descripcion: "Tentáculo de pulpo tierno asado al carbón, servido con papas cambray y chimichurri de la casa.",
    categoria: "mariscos",
    imagen: IMAGES.SEAFOOD_RESTAURANT_10,
    esPopular: false,
    origen: "Medusas"
  },
  {
    id: "m6",
    nombre: "Margarita de Pitaya",
    precio: 165,
    descripcion: "Tequila reposado, licor de naranja, jugo de limón fresco y pulpa natural de pitaya sinaloense.",
    categoria: "bebidas",
    imagen: IMAGES.TROPICAL_SUNSET_6,
    origen: "Medusas"
  }
];

export const testimonios: Testimonio[] = [
  {
    id: "t1",
    nombre: "Valeria Mendoza",
    comentario: "La mejor experiencia en El Maviri. Las cabañas son súper cómodas y la comida del restaurante es simplemente espectacular. ¡El pescado zarandeado es imperdible!",
    calificacion: 5,
    fecha: "2026-01-15",
    servicioVisitado: "Cabañas Las Gaviotas"
  },
  {
    id: "t2",
    nombre: "Ricardo Sánchez",
    comentario: "Medusas tiene un ambiente increíble para cenar. Los cócteles son de otro nivel y la vista al atardecer es la mejor de toda la playa.",
    calificacion: 5,
    fecha: "2026-02-10",
    servicioVisitado: "Restaurante Medusas"
  },
  {
    id: "t3",
    nombre: "Elena Castro",
    comentario: "Un lugar familiar por excelencia. Llevamos años viniendo a Las Gaviotas y la calidad nunca baja. Excelente servicio de todo el personal.",
    calificacion: 4,
    fecha: "2026-02-20",
    servicioVisitado: "Restaurante Las Gaviotas"
  }
];

export const servicios = [
  {
    titulo: "Eventos Especiales",
    descripcion: "Organizamos bodas, aniversarios y reuniones corporativas frente al mar.",
    icono: "Users"
  },
  {
    titulo: "Acceso a Playa",
    descripcion: "Contamos con camastros y sombrillas exclusivas para nuestros huéspedes.",
    icono: "Umbrella"
  },
  {
    titulo: "Transporte",
    descripcion: "Servicio de transporte desde Los Mochis y Topolobampo bajo reserva.",
    icono: "Car"
  },
  {
    titulo: "Wi-Fi Gratuito",
    descripcion: "Conectividad total en todas nuestras instalaciones para tu comodidad.",
    icono: "Wifi"
  }
];